export default "__VITE_ASSET__C4s35yJP__";